import { apiRequest } from '../api/api'
import { API_ENDPOINTS } from '../utils/constants'

// Single chokepoint for cart mutations: emit a lightweight window event after a
// successful change so any listener (e.g. the header cart badge) can refresh —
// no store/framework, no polling. Every cart change already flows through here.
export const CART_CHANGED_EVENT = 'cart:changed'
function emitCartChanged () {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new Event(CART_CHANGED_EVENT))
  }
}
const withEmit = promise => promise.then(res => { emitCartChanged(); return res })

const cartService = {
  createCart () {
    return apiRequest(`${API_ENDPOINTS.CART}/create`, {
      method: 'POST'
    })
  },

  getCart () {
    return apiRequest(API_ENDPOINTS.CART)
  },

  addToCart (data) {
    return withEmit(apiRequest(`${API_ENDPOINTS.CART}/add-product`, {
      method: 'POST',
      body: data
    }))
  },

  updateQuantity (data) {
    return withEmit(apiRequest(`${API_ENDPOINTS.CART}/update-product`, {
      method: 'PUT',
      body: data
    }))
  },

  // Shift the whole active cart to a new start date (reorder rescheduling).
  rescheduleDates (data) {
    return apiRequest(`${API_ENDPOINTS.CART}/reschedule`, {
      method: 'PUT',
      body: data
    })
  },

  removeItem (mappingId) {
    return withEmit(apiRequest(`${API_ENDPOINTS.CART}/remove-product/${mappingId}`, {
      method: 'DELETE'
    }))
  },

  clearCart () {
    return withEmit(apiRequest(`${API_ENDPOINTS.CART}/clear`, {
      method: 'DELETE'
    }))
  }
}

export default cartService
